/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { toggleOptionCard } from '../../../actions/ViewController';

class RoleCardDoneButton extends Component {
    hidePopout() {
        this.props.toggleOptionCard();
    }

    render() {
        return (
            <button
                className="role-done-button"
                onClick={this.hidePopout.bind(this)}
            >
                Done
            </button>
        );
    }
}

export default connect(null, { toggleOptionCard })(RoleCardDoneButton);
